import {
  DATA_ORIGINAL_TABINDEX,
  TABINDEX_ATTRIBUTE,
  TABINDEX_DISABLED_VALUE,
  ARIA_HIDDEN_ATTRIBUTE,
  ARIA_HIDDEN_TRUE_VALUE,
  FOCUSABLE_SELECTOR,
  INTERSECTION_THRESHOLDS,
  VISIBILITY_THRESHOLD
} from "../constants";
import logger from "../../../lib/logger";

export const manageFocusableElements = (elements, shouldEnable) => {
  elements.forEach(el => {
    if (shouldEnable) {
      if (el.hasAttribute(DATA_ORIGINAL_TABINDEX)) {
        el.setAttribute(
          TABINDEX_ATTRIBUTE,
          el.getAttribute(DATA_ORIGINAL_TABINDEX)
        );
        el.removeAttribute(DATA_ORIGINAL_TABINDEX);
      } else {
        el.removeAttribute(TABINDEX_ATTRIBUTE);
      }
    } else {
      if (
        el.hasAttribute(TABINDEX_ATTRIBUTE) &&
        el.getAttribute(TABINDEX_ATTRIBUTE) !== TABINDEX_DISABLED_VALUE
      ) {
        el.setAttribute(
          DATA_ORIGINAL_TABINDEX,
          el.getAttribute(TABINDEX_ATTRIBUTE)
        );
      }
      el.setAttribute(TABINDEX_ATTRIBUTE, TABINDEX_DISABLED_VALUE);
    }
  });
};

export const setElementAccessibility = (element, isVisible) => {
  if (isVisible) {
    element.removeAttribute(ARIA_HIDDEN_ATTRIBUTE);
    element.removeAttribute(TABINDEX_ATTRIBUTE);
  } else {
    element.setAttribute(ARIA_HIDDEN_ATTRIBUTE, ARIA_HIDDEN_TRUE_VALUE);
    element.setAttribute(TABINDEX_ATTRIBUTE, TABINDEX_DISABLED_VALUE);
  }
};

export const resetChildAccessibility = (listElement, observer) => {
  if (!listElement) return;

  if (observer) {
    observer.disconnect();
  }

  const children = listElement.children;
  if (!children) return;

  Array.from(children).forEach(child => {
    child.removeAttribute(ARIA_HIDDEN_ATTRIBUTE);
    child.removeAttribute(TABINDEX_ATTRIBUTE);

    const focusableElements = child.querySelectorAll(FOCUSABLE_SELECTOR);
    manageFocusableElements(focusableElements, true);
  });
};

export const createIntersectionObserver = (rootElement, callback) => {
  try {
    const observerOptions = {
      root: rootElement,
      rootMargin: "0px",
      threshold: INTERSECTION_THRESHOLDS
    };

    return new IntersectionObserver(callback, observerOptions);
  } catch (error) {
    const errorText =
      "Failed to initialize IntersectionObserver in HorizontalScrollList";
    logger.warn(new Error(`${errorText}: ${error.message}`));

    return null;
  }
};

export const checkIntersectionObserverSupport = () => {
  if (!window.IntersectionObserver) {
    const errorText =
      "IntersectionObserver not supported in HorizontalScrollList";
    logger.warn(new Error(errorText));

    return false;
  }

  return true;
};

export const createIntersectionCallback = () => entries => {
  entries.forEach(entry => {
    const child = entry.target;
    const isFullyVisible = entry.intersectionRatio >= VISIBILITY_THRESHOLD;

    setElementAccessibility(child, isFullyVisible);

    const focusableElements = child.querySelectorAll(FOCUSABLE_SELECTOR);
    manageFocusableElements(focusableElements, isFullyVisible);
  });
};
